export const ENUM_LOAD = 'ENUM_LOAD'
export const enumLoad = payload => ({
  type: ENUM_LOAD,
  payload
})

export const ENUM_FORM_ATTRIBUTES = 'ENUM_FORM_ATTRIBUTES'
export const enumFormAttributes = entities => ({
  type: ENUM_FORM_ATTRIBUTES,
  payload: { entities }
})

export const ENUM_FETCH_ERROR = 'ENUM_FETCH_ERROR'
export const enumFetchError = payload => ({
  type: ENUM_FETCH_ERROR,
  error: true,
  payload
})

// S3DEV2-7673: the first-time registration assignee list is Administrator only, so it is fetched when the
// dashboard opens instead of on every login.
export const FETCH_SAS_COMPANY_ADMINISTRATORS = 'FETCH_SAS_COMPANY_ADMINISTRATORS'
export const fetchSasCompanyAdministrators = () => ({
  type: FETCH_SAS_COMPANY_ADMINISTRATORS
})
